import type { I18nextKey, I18nextTFunction } from "@sg-protect/federation-runtime";
import { createI18nextInstance, useI18nextTranslation } from "@sg-protect/federation-runtime/i18n";
import type { ModuleRegisterFunction } from "../moduleRegisterFunction.ts";
import { en } from "./en.ts";

declare module "@sg-protect/federation-runtime" {
    interface I18nextResources {
        shell: typeof en;
    }
}

const shellI18next = createI18nextInstance("shell", en, {
    fr: async () => (await import("./fr.ts")).fr,
    de: async () => (await import("./de.ts")).de,
    es: async () => (await import("./es.ts")).es,
    nl: async () => (await import("./nl.ts")).nl
});

export const registerShellI18next: ModuleRegisterFunction = runtime => {
    shellI18next.register(runtime);
};

export type ShellTFunction = I18nextTFunction<"shell">;

export type ShellTranslationKey = I18nextKey<"shell">;

export function useShellTranslation() {
    return useI18nextTranslation("shell", shellI18next.instance);
}
